import React from "react";

import BoxGrid from "@/main/components/shared/boxGrid/boxGrid";
import KOGPaginationGrid from "@/main/components/shared/paginationGrid/paginationGrid";

import { procurementReportApi } from "@/main/api";
import { getTranslateByFullKey, getTranslateByKey } from "@/main/services/utils";
import { SearchGridRequoteTraceabilityRequest } from "@/main/models/request";

import RowDataRequoteTraceability from "./rowDataRequoteTraceability/rowDataRequoteTraceability";
import * as S from "./styles";
import { SearchGridRequoteTraceabilityResponse } from "@/main/models/response";

interface IGridRequoteTraceabilityProps {
	dataGrid: SearchGridRequoteTraceabilityResponse[];
	formFilters: SearchGridRequoteTraceabilityRequest | null;
	setDataGrid: React.Dispatch<React.SetStateAction<any[]>>;
}

function GridRequoteTraceability({ dataGrid, formFilters, setDataGrid }: IGridRequoteTraceabilityProps) {
	const rowsHeader = [
		getTranslateByKey("information.insurer"),
		getTranslateByKey("information.action"),
		getTranslateByKey("information.originalQuoteNr"),
		getTranslateByKey("screen.user"),
		getTranslateByKey("information.quoteNr"),
		getTranslateByKey("information.quoteStatus"),
		getTranslateByKey("information.quotePartStatus"),
		<S.TextCenter key="7">{getTranslateByKey("information.requotes")}</S.TextCenter>,
		getTranslateByKey("information.quoteDate"),
		getTranslateByKey("information.claimNumb"),
		getTranslateByKey("information.policyNumb"),
		getTranslateByFullKey("t.nah.quoteCard.partName"),
		getTranslateByKey("information.bodyshopRFC"),
		getTranslateByKey("information.bodyshop"),
	].filter(Boolean);

	const RowsGroup = [
		"100px", // Insurer
		"100px", // Action
		"80px", // Original quote nr
		"100px", // User
		"80px", // Quote nr
		"100px", // Quote status
		"100px", // Quote part status
		"80px", // Requotes
		"100px", // Quote date
		"100px", // Claim nr
		"80px", // Policy nr
		"80px", // Part name
		"80px", // Bodyshop RFC
		"100px", // Bodyshop
	].filter(Boolean) as string[];

	async function fetchDataGrid(request: any) {
		return procurementReportApi.searchGridRequoteTraceability(request).then((response) => response.data);
	}

	return (
		<S.Container>
			<KOGPaginationGrid
				showTitleResults
				dataGrid={dataGrid}
				formFilters={formFilters}
				setDataGrid={setDataGrid}
				fetchMore={fetchDataGrid}
			>
				<BoxGrid rowHeaders={rowsHeader} sizeColumns={RowsGroup} sizeCell="medium" breakpointTable={1100}>
					{dataGrid.map((item, index) => (
						<RowDataRequoteTraceability key={"row-data-filter-requote-traceability-" + index} itemRow={item} />
					))}
				</BoxGrid>
			</KOGPaginationGrid>
		</S.Container>
	);
}

export default GridRequoteTraceability;
